<template>
    <div id="cate-nav">
        <div id="nav-scroll">
            <div class="scroll-list" :style="{width: navWidth}">
                <ul>
                    <li v-for="item in navList"
                        :class="{active: currentNav === item.parameterId}"
                        @click="switchNav(item.parameterId)">
                        <span>{{item.parameterName}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    //导入模块
    import CONF from '@/app.conf.json';
    import Server from '../../services/Index';

    export default {
        name: "CateNav",
        props: {
            navList: {
                type: Array
            }
        },
        data() {
            return {
                currentNav: this.navList[0].parameterId,
                navWidth: ""
            }
        },
        mounted () {
            let _this = this;

            this.$emit('listenChild', {catalogueId: _this.currentNav});
            setTimeout(() => {

                // 下面这行放到iscrollLite加载完成，不可滑动、、、
                _this.navWidth = (750 - 20 * 2) / 4 * _this.navList.length / 50 + 'rem';

                $.loadMod(MOD_URL.iscrollLite).done(function () {

                    let UA = window.navigator.userAgent;

                    new IScroll('#nav-scroll', {
                        scrollX: true,
                        scrollY: false,
                        tap: true,
                        useTransform: (UA.match(/(MI|vivo|MX);?/i) && UA.match(/(SNEBUY-APP);?/i)) ? false : true,
                        eventPassthrough: true
                    });
                });
            }, 20);
        },
        methods: {

            switchNav(type) {

                this.currentNav = type;
                this.$emit('listenChild', {catalogueId: type});
            }
        }
    }
</script>
<style scoped>
    #cate-nav {
        background: #fff;
        height: 85px;
        font-weight: bold;
        border-bottom: 1px solid #f2f2f2;
        ul {
            width: 100%;
            height: 100%;

            li {
                text-align: center;
                height: 100%;
                float: left;
                width: calc((750px - 20px * 2) / 4);

                span {
                    padding: 2px 10px;
                    border-radius: 3px;
                    border: 1px solid #fff;
                }

                &.active {
                    /*border-bottom: 4px solid #ffaa00;*/
                    color: #ffaa00;

                    span {
                        padding: 2px 10px;
                        border-radius: 3px;
                        border: 1px solid #ffaa00;
                    }
                }
            }
        }

        #nav-scroll {
            position: relative;
            line-height: 88px;
            overflow: hidden;
            height: 88px;

            .scroll-list {
                height: 100%;
                position: absolute;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/StationCateNav.vue